export default "__VITE_ASSET__gyiLEGC2__"